export default "__VITE_ASSET__FXCGBwpl__"